// extracted by mini-css-extract-plugin
export default {"grid":"App_grid__71kR+"};